// src/assets/data/languageCodes.js

// 1) assign to a variable
const languageCodes = {
  Arabic: "ar",
  Bengali: "bn",
  Chinese: "zh",
  French: "fr",
  German: "de",
  Greek: "gr",
  Hindi: "hi",
  Italian: "it",
  Japanese: "jp",
  Kannada: "kn",
  Latin: "la",
  Malayalam: "ml",
  Marathi: "mr",
  Portuguese: "pt",
  Punjabi: "pa",
  Russian: "ru",
  Spanish: "es",
  Tamil: "ta",
  Telugu: "te",
  Urdu: "ur",
};

// 2) default-export the named variable
export default languageCodes;
